// Legacy: `nl2br` pipe applied to summary / highlight / entry description HTML
// across architect-template, modern-template, classic-template, minimal-template.

import DOMPurify from 'isomorphic-dompurify';

const ALLOWED_TAGS = ['p', 'br', 'ul', 'ol', 'li', 'b', 'strong', 'i', 'em', 'u', 'span', 'a'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

/** Sanitize rich-text HTML (entry/summary descriptions) before `dangerouslySetInnerHTML`. */
export function sanitizePortfolioHtml(raw: string | null | undefined): string {
  if (raw == null || raw === '') {
    return '';
  }
  return DOMPurify.sanitize(String(raw), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
}

/**
 * Legacy `nl2br` pipe: convert bare newlines to `<br>` then sanitize. Descriptions
 * coming from the editor may be either plain text or already contain HTML tags.
 */
export function nl2brSanitize(raw: string | null | undefined): string {
  if (raw == null || raw === '') {
    return '';
  }
  const withBreaks = String(raw).replace(/\r\n|\r|\n/g, '<br>');
  return sanitizePortfolioHtml(withBreaks);
}

export function allowlistedEmbedUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\./, '').toLowerCase();
    if (
      host === 'youtube.com' ||
      host === 'youtube-nocookie.com' ||
      host === 'youtu.be' ||
      host === 'vimeo.com' ||
      host === 'player.vimeo.com'
    ) {
      return parsed.toString();
    }
  } catch {
    return null;
  }
  return null;
}
